import { render, staticRenderFns } from "./SalaryReportByBank.vue?vue&type=template&id=9891d110"
import script from "./SalaryReportByBank.vue?vue&type=script&lang=js"
export * from "./SalaryReportByBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports